import CompanySearchForm from 'vcomponents/companysearch/CompanySearchForm.vue';
import { h, render } from 'vue';

window.CompanySearch = {

    createMassThird(rows, countryCode, activeFilters) {
        let options = {
			type	: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Confirmation de création de prospect"),
			buttons		: [
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}},
				{text :
					Loc.g("Créer les prospects"),
					click : function() {
                        SellsyJS.WebServiceCaller.post('/companysearch/massCreateCorp', {}, {
                            companies : rows,
                            countryCode : countryCode,
                            activeFilters : activeFilters
                        }, (response) => {

                            $(this).dialog("close");
                            MyWindow.alert((window.i18n.__("Il nous faut quelques minutes pour enregistrer toutes ces nouvelles informations dans votre base.") + "<br/><br/>"  + window.i18n.__('Vous serez informé quand cette opération sera terminée.')), {
                                "title"     : window.i18n.__("En cours d'éxécution"),
                                'noclose'   : true,
                                'resizable'	: false,
                                buttons		: [
                                    {text : window.i18n.__("Ok"), click : function(){$(this).dialog("close")}},
                                ]
                            })
                        }, (error) => {

                            $(this).dialog("close");

                            if(error.response.data.error && error.response.data.error.message) {
                                Push.error(error.response.data.error.message);
                            } else {
                                Push.error(window.i18n.__('Une erreur est survenue'));
                            }
                        });
					}
				}
			]
        };

        MyWindow.alert(window.i18n.n__(
            "Vous vous apprétez à créer %(nb)d prospect dans votre base",
            "Vous vous apprétez à créer %(nb)d prospects dans votre base",
            rows.length,
            {'nb' : rows.length}),
            options
        );
    },

    /**
     * Return the right wording  for label, depending country
     * @param {string} label
     * @param {string} country
     */
    getLabelForCountry(label, country) {
        const labels = {
            "companyId" : {
                "FR" : window.i18n.__("N° Siren"),
                "GB" : window.i18n.__("Identifiant société"),
            },
            "jobCode" : {
                "FR" : window.i18n.__("Code NAF (APE)"),
                "GB" : window.i18n.__("Code SIC"),
            },
        };

        if(!labels[label]) {
            return "";
        }

        if(!labels[label][country]) {
            return "";
        }

        return labels[label][country];

    },
    getComponentCompanySearch(container, context, thirdName, district)
    {
		thirdName = thirdName ? thirdName.replaceAll(/&/g, '&amp;')
			.replaceAll(/</g, "&lt;")
			.replaceAll(/>/g, "&gt;")
			.replaceAll(/"/g, "&quot;") : '';
        const containerElement = document.getElementById(container);

        if (containerElement) {
            const vnode = h(CompanySearchForm, { context, thirdName, district });

            vnode.appContext = window.sellsyapp.appContext;
            render(vnode, containerElement);
        }
    },
    /**
	 *
	 * @param Integer thirdid
	 */
	modalUpdate: function(thirdid) {

		var options = {
			title: Loc.g('Compléter la fiche client'),
			buttons:
                [
                    {text: Loc.g("Annuler"), click: function() {
                        $(this).dialog("close");
                    }}
                ],
			width: 950,
			callback: function() {
				var formOpt = {
					dataType: 'json',
					success: function() {
						Utils.reload();
					}
                };

                // Add company searchForm
                var thirdName   = $("#companysearch_thirdName").val();
                var district    = $("#companysearch_thirdDistrict").val();
                window.CompanySearch.getComponentCompanySearch('third-companysearch-form', 'update', thirdName, district);
                MyForm.prepare("modalSearchForm", `/companysearch/updatethird/${thirdid}`, formOpt, true, true, false);

			}
		};

		MyWindow.load(`/companysearch/modalsearch/${thirdid}`, {}, options, null, undefined, undefined, "GET", false);
    },

    /**
	 *
	 * @param Object financialActivity
	 */
	addFinancialActivity: function(financialActivity) {
		// Financial activity

		$('.td-placeholder').remove();
		$('#financialActivity tbody tr').remove();

		if (financialActivity != undefined && financialActivity.length > 0) {
			var precActivity = null;

			var numformat = NumberFormat.loadFromInputs('numformat_');

			for (var i = 0; i < financialActivity.length; i++) {

				var activity = financialActivity[i];

				if (activity.turnover !== '' || activity.income !== '' || activity.workforce_count !== '') {
					var $tr = $('<tr></tr>');

					$tr.append('<td class="aleft">'
							+ (activity.publication_year !== null ? activity.publication_year : 'nc.')
							+ '<input type="hidden" name="activity[' + i + '][publication_year]" value="' + (activity.publication_year !== null ? activity.publication_year : '') + '" />'
							+ '</td>');

					$tr.append('<td class="aleft">'
							+ (activity.publication_date !== null ? activity.publication_date : 'nc.')
							+ '<input type="hidden" name="activity[' + i + '][publication_date]" value="' + (activity.publication_date !== null ? activity.publication_date : '') + '" />'
							+ '</td>');

					var turnoverTrend = '';
					if (activity.turnover !== null && i > 0) {
						if (activity.turnover > precActivity.turnover) {
							turnoverTrend = '<i class="fa fa-chevron-up fa-green fleft"></i>';
						} else if (activity.turnover < precActivity.turnover) {
							turnoverTrend = '<i class="fa fa-chevron-down fa-red fleft"></i>';
						}
					}

					$tr.append('<td class="aleft">'
							+ turnoverTrend
							+ (activity.turnover !== null ? NumberFormat.formatToDisplay(activity.turnover, numformat, true) : 'nc.')
							+ '<input type="hidden" name="activity[' + i + '][turnover]" value="' + (activity.turnover !== null ? activity.turnover : '') + '" />'
							+ '</td>');


					var incomeTrend = '';
					if (activity.income !== null && i > 0) {
						if (activity.income > precActivity.income) {
							incomeTrend = '<i class="fa fa-chevron-up fa-green fleft"></i>';
						} else if (activity.income < precActivity.income) {
							incomeTrend = '<i class="fa fa-chevron-down fa-red  fleft"></i>';
						}
					}

					$tr.append('<td class="aleft">'
							+ incomeTrend
							+ (activity.income !== null ? NumberFormat.formatToDisplay(activity.income, numformat, true) : 'nc.')
							+ '<input type="hidden" name="activity[' + i + '][income]" value="' + (activity.income !== null ? activity.income : '') + '" />'
							+ '</td>');

					$tr.append('<td class="aleft">'
							+ (activity.workforce_count !== null ? activity.workforce_count : 'nc.')
							+ '<input type="hidden" name="activity[' + i + '][workforce_count]" value="' + (activity.workforce_count !== null ? activity.workforce_count : '') + '" />'
							+ '</td>');

                    $tr.appendTo('#financialActivity tbody');
				}

				precActivity = activity;
			}
		} else {
			var $tr = $('<tr></tr>');

			$tr.append('<td class="td-placeholder" colspan="5">'
					+ '<div class="placeholder">' + Loc.g('Aucune donnée financière n‘est disponible pour cette société') + '</div>'
					+ '</td>');

			$tr.appendTo('#financialActivity tbody');

		}

		$('#thirdActivity').slideDown('fast');

    },
};
